import React from "react"
import { Footer } from "./Footer"
import { Header } from "./Header"

export const Layout = ({ children }) => {
    return (
        <React.Fragment>
            {<Header />}
            <div className="layout__content">
                {children}
            </div>
            {<Footer />}
        </React.Fragment>
    )
}